import React, {useState, useEffect} from "react"
import transcriptData from "./transcriptData"

function PuzzleIntro(props) {
    let [audioPlaying, setAudioPlaying] = useState(false)
    
    function playAudio() {
        const audioClip = document.getElementById('recordingLarryMain')
        if (!audioPlaying) {
            setAudioPlaying(true)
            audioClip.play()
        } else {
            audioClip.pause();
            setAudioPlaying(false)
        }
    }
    
    useEffect(() => {
        setAudioPlaying(false)
    }, [props.currentPage])
    
    return (
        <div className="titleWrapper">
            <div className="phaseTitle">
                <h1>The Disappearing Diamond</h1>
                <h2>Part {props.currentPage}</h2>
            </div>

            <div className="audioControl">
                <button className="standardButton" onClick={playAudio}>Play Recording</button>
                <h4 className="transcriptLink"><a href={transcriptData[props.currentPage][0].source} target="_blank" rel="noopener noreferrer">View Transcript</a></h4>
            </div>
        </div>
    )
}

export default PuzzleIntro